import { render, staticRenderFns } from "./crudConcepts.vue?vue&type=template&id=d135e7ac&"
import script from "./crudConcepts.vue?vue&type=script&lang=js&"
export * from "./crudConcepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports